/** DOM lookups on the viewer's scroller (page boxes carry data-page). */
import type { ViewerHandle } from '../viewer/types';

/** Elements inside a page that keep their own behaviour (pins, buttons, form fields). */
export const INTERACTIVE_SELECTOR = 'button, a, input, textarea, select, [data-annot-ignore]';

export function pageElement(scroller: HTMLElement | null, page: number): HTMLElement | null {
  return scroller?.querySelector<HTMLElement>(`[data-page="${page}"]`) ?? null;
}

export function pageClientRect(handle: ViewerHandle | null, page: number): DOMRect | null {
  return pageElement(handle?.getScrollElement() ?? null, page)?.getBoundingClientRect() ?? null;
}

export function isEditableTarget(t: EventTarget | null): boolean {
  if (!(t instanceof HTMLElement)) return false;
  return t.isContentEditable || t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT';
}
